/*
    Automatically restore the values of inputs and selects 
    from either query string or form state object.
*/
define('shared/initializer/form/adapters/mixins/InputValueRecoverable',[
    '$',
    'shared/util/dispatchers/FormDataDispatcher'
], 
function ( $, FormDataDispatcher) {
    'use strict';

    function getQuerySources(key) {
        var ret = [{type: 'query', key: key, caseSensitive: false}];

        switch(key) {
            case 'firstname':
                ret.push({type: 'query', key: 'first_name', caseSensitive: false});
            break;
            case 'lastname':
                ret.push({type: 'query', key: 'last_name', caseSensitive: false});
            break;
        }

        return ret;
    }

    function Ctor() { }

    Ctor.prototype.doPageLoad = function( ) {
        var me = this;
        var dispatcher = new FormDataDispatcher(me.$form);

        // collect item info from form
        var dispatchingItems = {};
        var $curItem;
        var keyWithCase;
        
        for(var key in me.items) {
            if (!me.items.hasOwnProperty(key)) {
                continue;
            }

            $curItem = me.items[key].$el;
            if (
                !$curItem.is(':visible') ||
                $curItem.is('input[type=hidden]') ||
                $curItem.is('input[type=password]')
            ) {
                continue;
            }

            keyWithCase = $curItem.attr('name');

            dispatchingItems[key] = {
                sources: [
                    {type: 'form', key: keyWithCase, allowEmpty: false}
                ]
                .concat(getQuerySources(key))
                .concat([{type: 'state', key: 'form.' + keyWithCase, allowUndefined: true}]),
                targets: [
                    {type: 'form', key: keyWithCase, ignoreNull: true}
                ],
                allowUndefined: true
            };
        }

        return dispatcher.dispatch({
            timeout: 1000 * 60 * 60,
            items: dispatchingItems
        });
    };

    return Ctor;
});
